import axios from 'axios';

export class Subscriber {
  static async create(data) {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/subscribers`, data);
      return response.data;
    } catch (error) {
      console.error('Error subscribing:', error);
      const err = new Error('Failed to subscribe');
      if (error.response) {
        err.response = {
          status: error.response.status,
          data: error.response.data,
        };
      }
      throw err;
    }
  }
}
